var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('stepper',{staticClass:"redeem-stepper",attrs:{"currentStep":_vm.currentStep,"steps":[{ name: 'conta' }, { name: 'cliente SKY' }, { name: 'feito!' }]}})}
var staticRenderFns = []

export { render, staticRenderFns }